<template>
    <div class="news-detail">
        <h1 v-if="isShowWN" style="display: none;">海洋奇迹号</h1>
        <div class="newsCenterDetail--banner">
            <img :src="(newsDetail.bannerUrl || 'https://resource.rcclchina.com.cn/newsCenter/detail_banner1.jpg')">
            <div class="banner--title">
                <h3 class="title--txt">{{newsDetail.newsTitle}}</h3>
                <img src="https://resource.rcclchina.com.cn/newsCenter/img/time-banner.png">
                <span class="publish-time">发布时间：{{newsDetail.createdUtc}}</span>
            </div>
            <div class="bg-shadow"></div>
        </div>
        <div class="newsCenterDetail--content">
            <div class="test">
                <div class="detail--content" v-html="newsDetail.newsTest"></div>
            </div>
        </div>
        <div class="backList--content">
            <div class="backlist">
                <div class="list--pre">
                    <img src="https://resource.rcclchina.com.cn/newsCenter/img/preList.png">
                    <a v-if="newsDetail.preNewsTitle" :href="`/Rccl.CustomPage/RcclNews/Detail/${newsDetail.preNewsId}.html`">
                        <span>上一篇：</span>{{interceptChar(newsDetail.preNewsTitle, 36)}}
                    </a>
                </div>
                <div class="back--list">
                    <img src="https://resource.rcclchina.com.cn/newsCenter/img/listIcon.png">
                    <a href="/Rccl.CustomPage/RcclNews">返回列表</a>
                </div>
                <div class="back--next">
                    <a v-if="newsDetail.nextNewsTitle" :href="`/Rccl.CustomPage/RcclNews/Detail/${newsDetail.nextNewsId}.html`">
                        <span>下一篇：</span>{{interceptChar(newsDetail.nextNewsTitle, 36)}}
                    </a>
                    <img src="https://resource.rcclchina.com.cn/newsCenter/img/nextList.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { interceptChar } from '@/utilities/tools'

    export default {
        name: 'RcclNewsDetail',
        components: {},
        data () {
            return {
                newsDetail: {},
            }
        },
        beforeMount () {
            this.initPage()
        },
        methods: {
            interceptChar (str, num) {
                return interceptChar(str, num)
            },
            async initPage () {
                const newsId = this.$route.params.id
                this.newsDetail = await this.getDetail(newsId)
                if (this.newsDetail) {
                    const title = this.newsDetail.newsTitle + '|皇家加勒比国际游轮官方网站'
                    const description = this.newsDetail.viewBagSeoDescription
                    const keyword = this.newsDetail.viewBagSeoKeywords
                    this.$store.commit('SET_META', { title, description, keyword })
                }
            },
            async getTitle (newsId) {
                const {success, data, errMsg} = await api.page.getNewsTitle(newsId)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            async getDetail (newsId) {
                this.$loading.show()
                const {success, data, errMsg} = await api.page.getNewsDetail(newsId)
                this.$loading.hide()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            }
        },
        computed: {
            isShowWN () {
                const newsId = this.$route.params.id
                return ["1166239", "1150074", "963306", "931149"].indexOf(newsId) >= 0
            }
        }
    }
</script>

<style scoped>
    .newsCenterDetail--banner{
        width:100%;
        position: relative;
        overflow: hidden;

    }
    .newsCenterDetail--banner>img{
        width:100%;
    }
    .banner--title{
        width:100%;
        position: absolute;
        bottom: 28px;
        text-align: center;
        height: 78px;
        color: #fff;
        z-index:1;
    }
    .banner--title .publish-time {
        margin-left: 3px
    }
    .newsCenterDetail--banner .bg-shadow{
        position:absolute;
        top:0;
        width:100%;
        height:100%;
        background:rgba(0,0,0,.2);
        filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#33ffffff,endColorstr=#33ffffff);
    }
    .newsCenterDetail--content{
        width:100%;
        background: #f0f0f0;
        padding: 24px 0;
    }
    .detail--content{
        width:1142px;
        margin: 0 auto;
        background: #fff;
        padding: 1px 20px 90px;
        border-radius: 5px;
    }
    .detail--content .intro--img{
        text-align: center;
    }
    .detail--content .intro--img img{
        width:680px;
    }
    .detail--content >>> p{
        margin: 30px 0;
        line-height: 30px !important;
    }
    .detail--content >>> img{
        display: block;
        width: 680px;
        height: auto;
        margin: 0 auto 10px;
    }
    .detail--content >>> .MsoNormal{
        margin: 0;
    }
    .backList--content{
        width:100%;
        background: #f0f0f0;
        padding-bottom: 90px;
    }
    .backList--content .backlist{
        width:1142px;
        margin: 0 auto;
        background: #fff;
        border-radius: 5px;
        height: 80px;
        line-height: 80px;
        padding: 0 20px;
    }
    .backlist .list--pre{
        width:482px;
        float: left;
    }
    .backlist .back--list{
        width: 135px;
        float: left;
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        text-align: center;
    }
    .backlist .back--next{
        width: 482px;
        float: left;
        text-align: right;
    }
    .backlist .list--pre img,
    .backlist .back--list img{
        display: inline-block;
        vertical-align: middle;
        margin-right: 3px;
    }
    .backlist .back--next img{
        display: inline-block;
        vertical-align: middle;
        margin-left: 3px;
    }
    .backlist .list--pre a,
    .backlist .back--list a,
    .backlist .back--next a{
        display: inline-block;
        vertical-align: middle;
        max-width: 474px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
</style>
